export const MODEL_DISABLE_TIMEOUT = 500
export const MODAL_ABORT_CONTROLLER_TIMEOUT = 200
export const MODAL_ABORT_CONTROLLER_MESSAGE = "RESET"
export const DEFAULT_DISPLAY_DECIMALS = 5
